import { createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import { getDateOnly } from "src/utils/getDateOnly";
import { getRemoteConfigValue } from "../index";

const initialState = {
  availableVideoUsage: getRemoteConfigValue("freemium_video_usage_in_24_hours"),
  remainingVideoUsage: getRemoteConfigValue("freemium_video_usage_in_24_hours"),
  lastCheckDate: getDateOnly()
};

const firebaseSlice = createSlice({
  name: "firebase",
  initialState,
  reducers: {
    hydrateStore(state) {
      state.availableVideoUsage = getRemoteConfigValue("freemium_video_usage_in_24_hours");
      if (getDateOnly() > new Date(state.lastCheckDate)) {
        state.remainingVideoUsage = getRemoteConfigValue("freemium_video_usage_in_24_hours");
      }
    },

    setRemainingVideoUsage(state, { payload }) {
      state.remainingVideoUsage = payload;
    },
    setCheckDate(state) {
      state.lastCheckDate = getDateOnly();
    }
  }
});

export { firebaseSlice };
export default {
  createReducer: (storage) => {
    const persistConfig = {
      key: "firebase",
      whitelist: ["remainingVideoUsage", "lastCheckDate"],
      storage
    };
    return persistReducer(persistConfig, firebaseSlice.reducer);
  }
};
